/**
 * 获取月专报
 */
export function getMonthReportOption (option) {
  option.x = option.x.map(item => {
    if (item.length > 2) {
      item = item.slice(0, 2) + '\n' + item.slice(2)
    }
    return item
  })
  return {
    grid: {
      left: 50,
      right: 50,
      top: 50,
      bottom: 40
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      data: option.x
    },
    yAxis: {
      type: 'value',
      name: '（次数）'
    },
    series: [
      {
        data: option.y,
        type: 'bar',
        barWidth: 20,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 1,
            x2: 0,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: '#2D74F5'
              },
              {
                offset: 1,
                color: '#53A4FA'
              }
            ],
            global: false
          },
          barBorderRadius: [10, 10, 0, 0]
        }
      }
    ]
  }
}
/**
 * 获取年专报
 */
export function getYearReportOption (option) {
  option.x = option.x.map(item => {
    if (item.length > 2) {
      item = item.slice(0, 2) + '\n' + item.slice(2)
    }
    return item
  })
  return {
    grid: {
      left: 50,
      right: 50,
      top: 50,
      bottom: 40
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: option.x
    },
    yAxis: {
      type: 'value',
      name: '（次数）'
    },
    series: [
      {
        data: option.y,
        type: 'line',
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 1,
            x2: 0,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(2,86,247,0)'
              },
              {
                offset: 1,
                color: 'rgba(88,143,249,0.08)'
              }
            ],
            global: false
          }
        },
        itemStyle: {
          color: '#0256F7'
        }
      }
    ]
  }
}
